import React from 'react';
import { Col, Row } from 'components';
import { General } from 'feature/clientTabs/payments/general';
import { PaymentTerms } from 'feature/clientTabs/payments/paymentTerms';
import { SpecialPricingRules } from 'feature/clientTabs/payments/specialPricingRules';
import { PERMISSIONS } from 'constants/permissions';
import { HasAccess } from 'components/common/accessControl';
import { PricingRules } from 'feature/clientTabs/payments/pricingRules';

export const Payments = React.memo(() => {
  return (
    <Row gutter={40} wrap={false}>
      <Col span={12}>
        <Row gutter={[0, 32]}>
          <Col span={24}>
            <HasAccess role={PERMISSIONS.clients.payment_general.read}>
              <General />
            </HasAccess>
          </Col>
          <Col span={24}>
            <HasAccess role={PERMISSIONS.clients.payment_terms.read}>
              <PaymentTerms />
            </HasAccess>
          </Col>
          <Col span={24}>
            <HasAccess role={PERMISSIONS.clients.pricing_rules.read}>
              <PricingRules />
            </HasAccess>
          </Col>
        </Row>
      </Col>
      <Col span={12}>
        <HasAccess role={PERMISSIONS.clients.payment_special_pricing_rules.read}>
          <SpecialPricingRules />
        </HasAccess>
      </Col>
    </Row>
  );
});
